import { AppState } from "../../state";

export const isBuzzerEnabled = ({ location }: AppState) => {
    if (location.status !== "loaded") return false;
    return location.data.isBuzzer;
};
